module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/carousel_tiktok_mobile_03@2x-95f90a29b09ae6c3534705d5c191d66c.jpg";